import React, { useEffect, useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import './ScrollTopButton.css';

export default function ScrollTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || document.documentElement.scrollTop;
      setVisible(y > 300);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      // Fallback for older browsers
      window.scrollTo(0, 0);
    }
  };

  return (
    <button
      type="button"
      className={`scroll-top-btn ${visible ? 'show' : ''}`}
      aria-label="Scroll to top"
      onClick={scrollToTop}
    >
      <FaArrowUp />
    </button>
  );
}
